export function HeroLightRays() {
  const rayCount = 60;
  const rays = Array.from({ length: rayCount }, (_, i) => {
    // Distribute rays evenly in a full 360-degree circle
    const angle = (360 / rayCount) * i;
    return { angle, index: i };
  });

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Light mode rays */}
      <div className="absolute inset-0 dark:hidden">
        {/* Ray origin point behind input prompt bottom */}
        <div
          className="absolute"
          style={{
            left: '50%',
            bottom: '33%',
            width: '2px',
            height: '2px',
            animation: 'rotate-rays 320s linear infinite',
          }}
        >
          {/* Glow at origin - blue base */}
          <div
            className="absolute"
            style={{
              width: '600px',
              height: '600px',
              left: '-300px',
              bottom: '-300px',
              background: 'radial-gradient(circle, rgba(31, 71, 136, 0.4), transparent 70%)',
              filter: 'blur(60px)',
            }}
          />
          {/* Magenta-violet accent glow */}
          <div
            className="absolute"
            style={{
              width: '400px',
              height: '400px',
              left: '-200px',
              bottom: '-200px',
              background: 'radial-gradient(circle, rgba(233, 30, 99, 0.3) 0%, rgba(156, 39, 176, 0.2) 40%, transparent 70%)',
              filter: 'blur(40px)',
            }}
          />
          {rays.map(({ angle, index }) => {
            // Vary opacity and width for more dramatic effect
            const baseOpacity = 0.3;
            const opacityVariation = (Math.sin(index * 0.5) + 1) * 0.1;
            const opacity = baseOpacity + opacityVariation;
            const width = 6 + (Math.abs(index - rayCount / 2) / rayCount) * 4;

            return (
              <div
                key={index}
                className="absolute"
                style={{
                  width: `${width}px`,
                  height: '150vh',
                  bottom: '0',
                  left: '0',
                  transformOrigin: 'bottom center',
                  transform: `rotate(${angle}deg)`,
                  background: `linear-gradient(to top, rgba(31, 71, 136, ${opacity}), transparent 50%)`,
                  filter: 'blur(3px)',
                  boxShadow: `0 0 ${width * 2}px rgba(31, 71, 136, ${opacity * 0.5})`,
                }}
              />
            );
          })}
        </div>
      </div>

      {/* Dark mode rays */}
      <div className="absolute inset-0 hidden dark:block">
        {/* Ray origin point behind input prompt bottom */}
        <div
          className="absolute"
          style={{
            left: '50%',
            bottom: '35%',
            width: '2px',
            height: '2px',
            animation: 'rotate-rays 320s linear infinite',
          }}
        >
          {/* Glow at origin - blue base */}
          <div
            className="absolute"
            style={{
              width: '800px',
              height: '800px',
              left: '-400px',
              bottom: '-400px',
              background: 'radial-gradient(circle, rgba(31, 71, 136, 0.6), transparent 70%)',
              filter: 'blur(80px)',
            }}
          />
          {/* Magenta-violet accent glow */}
          <div
            className="absolute"
            style={{
              width: '500px',
              height: '500px',
              left: '-250px',
              bottom: '-250px',
              background: 'radial-gradient(circle, rgba(233, 30, 99, 0.5) 0%, rgba(156, 39, 176, 0.3) 40%, transparent 70%)',
              filter: 'blur(50px)',
            }}
          />
          {rays.map(({ angle, index }) => {
            // Vary opacity and width for more dramatic effect - brighter in dark mode
            const baseOpacity = 0.45;
            const opacityVariation = (Math.sin(index * 0.5) + 1) * 0.15;
            const opacity = baseOpacity + opacityVariation;
            const width = 7 + (Math.abs(index - rayCount / 2) / rayCount) * 5;

            return (
              <div
                key={index}
                className="absolute"
                style={{
                  width: `${width}px`,
                  height: '150vh',
                  bottom: '0',
                  left: '0',
                  transformOrigin: 'bottom center',
                  transform: `rotate(${angle}deg)`,
                  background: `linear-gradient(to top, rgba(31, 71, 136, ${opacity}), transparent 50%)`,
                  filter: 'blur(3px)',
                  boxShadow: `0 0 ${width * 3}px rgba(31, 71, 136, ${opacity * 0.6})`,
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
